import { createAction } from 'redux-actions';

export const PAGE_LOADING = 'PAGE_LOADING';
export const PAGE_LOADED = 'PAGE_LOADED';

export const pageLoading = createAction(PAGE_LOADING);
export const pageLoaded = createAction(PAGE_LOADED);
